import React from 'react';
import { experience } from '../data/mock';
import { Card, CardContent } from './ui/card';
import { Briefcase, MapPin, Calendar } from 'lucide-react';

const Experience = () => {
  const bgColor = '#ffffff';
  const textColor = '#1a2332';
  const accentColor = '#d4af37';

  return (
    <section id="experience" className="py-20" style={{ backgroundColor: bgColor, color: textColor }}>
      <div className="container mx-auto px-6">
        <div className="mb-16 text-center">
          <h2 className="mb-4 font-serif text-4xl font-bold md:text-5xl">Professional Journey</h2>
          <div className="mx-auto h-1 w-24 rounded" style={{ backgroundColor: accentColor }}></div>
          <p className="mx-auto mt-6 max-w-3xl text-lg opacity-90">
            15 years of transformative leadership in global talent acquisition
          </p>
        </div>

        <div className="relative">
          {/* Timeline line */}
          <div
            className="absolute left-8 top-0 hidden h-full w-1 md:block"
            style={{ backgroundColor: accentColor, opacity: 0.3 }}
          ></div>

          <div className="space-y-8">
            {experience.map((exp, index) => (
              <Card
                key={exp.id}
                className="border-none shadow-lg transition-all hover:scale-[1.02]"
              >
                <CardContent className="p-6 md:p-8">
                  <div className="flex flex-col gap-6 md:flex-row">
                    {/* Timeline dot */}
                    <div className="hidden md:block">
                      <div
                        className="relative -ml-12 mt-2 flex h-8 w-8 items-center justify-center rounded-full border-4 border-white shadow-lg"
                        style={{ backgroundColor: accentColor }}
                      >
                        <Briefcase className="h-4 w-4 text-white" />
                      </div>
                    </div>

                    <div className="flex-1">
                      <div className="mb-4 flex flex-wrap items-start justify-between gap-4">
                        <div>
                          <h3 className="mb-2 font-serif text-2xl font-bold" style={{ color: accentColor }}>
                            {exp.title}
                          </h3>
                          <p className="mb-1 text-xl font-semibold">{exp.company}</p>
                          <div className="flex flex-wrap gap-4 text-sm opacity-70">
                            <span className="flex items-center gap-1">
                              <Calendar className="h-4 w-4" />
                              {exp.duration}
                            </span>
                            <span className="flex items-center gap-1">
                              <MapPin className="h-4 w-4" />
                              {exp.location}
                            </span>
                          </div>
                        </div>
                      </div>

                      <ul className="space-y-2">
                        {exp.responsibilities.map((resp, idx) => (
                          <li key={idx} className="flex gap-3 text-base leading-relaxed">
                            <span
                              className="mt-2 h-1.5 w-1.5 flex-shrink-0 rounded-full"
                              style={{ backgroundColor: accentColor }}
                            ></span>
                            <span className="opacity-90">{resp}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Experience;
